import { useReducer, useEffect } from 'react';
import localCookie from '@liepin/native-sweet-fe'
import { AgreementKey } from '../modules/const';
import { ELoginType } from '../enum';
import { IInitialState, ILoginProps } from '../types';


const initialState: IInitialState = {
  checkedAgreement: localCookie.get(AgreementKey),
  handleCloseModal: null, // 关闭弹窗
  isModal: null, // 是否是弹窗
  loginIndexMark: 0, // 登录索引标记
  // 对外暴露的API
  loginType: null,
  onSuccess: null, // 登录成功（登录、注册）
  onLogin: null, // 登录成功（登录）
  onRegister: null, // 注册成功
  skipCheckResumeComplete: null, // 是否跳过校验完简
};

function reducer(state, { payload }) {
  return {
    ...state,
    ...payload,
  };
}


export default (loginProps: ILoginProps) => {

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const { onSuccess, onRegister, onLogin, handleCloseModal, skipCheckResumeComplete, isModal, loginType } = loginProps;
    // eslint-disable-next-line no-bitwise
    window.loginIndexMark = (window.loginIndexMark | 0) + 1;
    dispatch({
      payload: {
        onSuccess,
        onRegister,
        onLogin,
        handleCloseModal,
        skipCheckResumeComplete,
        isModal: isModal || false, // 默认不是弹窗
        loginType: loginType || ELoginType.Reg, // 默认短信验证码登录
        loginIndexMark: window.loginIndexMark,
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [state, dispatch];
}